import { type createStore } from 'jotai'

import { quoteSyncStatusAtom } from './quoteSync.atoms'

type JotaiStore = ReturnType<typeof createStore>

/**
 * Resolves once the quote has nothing left to save.
 *
 * It listens to the store rather than reading a rendered value, so a callback
 * created before the save started still sees it finish. Nothing times it out:
 * if a save never comes back, waiting forever is better than publishing a quote
 * the server hasn't been told about.
 */
export const waitForQuoteSyncIdle = (store: JotaiStore): Promise<void> =>
  new Promise<void>(resolve => {
    if (store.get(quoteSyncStatusAtom) === 'IDLE') {
      resolve()
      return
    }

    const unsubscribe = store.sub(quoteSyncStatusAtom, () => {
      if (store.get(quoteSyncStatusAtom) !== 'IDLE') {
        return
      }

      unsubscribe()
      resolve()
    })
  })
